module.exports = __webpack_public_path__ + "img/arrowDown.de712b47.svg";